import classNames from 'classnames';
import { motion } from 'motion/react';
import { Button } from 'react-aria-components/Button';
import { Dialog, DialogTrigger } from 'react-aria-components/Dialog';
import { Modal, ModalOverlay } from 'react-aria-components/Modal';

import Icon from '../../../../app/shared/components/Icon/Icon';
import LogoLink from '../../LogoLink/LogoLink';
import SearchBar from '../SearchBar/SearchBar';
import SiteHeaderState from '../SiteHeaderState';
import StoreAndLanguageSelectorSheet from '../StoreAndLanguageSelector/StoreAndLanguageSelectorSheet/StoreAndLanguageSelectorSheet';
import css from './HamburgerMenu.css';
import HamburgerMenuNav from './HamburgerMenuNav/HamburgerMenuNav';

const MotionSearchBar = motion.create(SearchBar);

interface HamburgerMenuProps {
  state: SiteHeaderState;
  className?: string;
}

export default function HamburgerMenu({ className, state }: HamburgerMenuProps) {
  return (
    <DialogTrigger>
      <Button className={classNames(css.trigger, className)} aria-label={state.translation.openMenuButton}>
        <div className={css.hamburger}>
          <div className={css.inner} />
        </div>
      </Button>
      <ModalOverlay className={css.overlay} isDismissable>
        <Modal className={css.modal}>
          <Dialog className={css.dialog} aria-label={state.translation.menuTitle}>
            <motion.div
              className={css.header}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.2 }}
            >
              <LogoLink href={state.homeUrl} />
              <Button slot="close" className={css.buttonClose} aria-label={state.translation.closeMenuButton}>
                <Icon className={css.icon} name="cross" />
              </Button>
            </motion.div>
            <div className={css.content}>
              {state.isSearchEnabled && (
                <MotionSearchBar
                  className={css.search}
                  translation={state.translation.search.searchBar}
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.25, ease: 'easeOut' }}
                  onSearch={state.searchInputState.submit}
                />
              )}
              <HamburgerMenuNav
                className={css.menu}
                items={state.menuItems}
                translation={state.translation.navigation}
              />
            </div>
            <motion.div
              className={css.footer}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.5, ease: 'easeOut' }}
            >
              <StoreAndLanguageSelectorSheet state={state.storeAndLanguageSelectorState} />
            </motion.div>
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
}
